import { render, staticRenderFns } from "./SpuLeading.vue?vue&type=template&id=6cc81688&scoped=true"
import script from "./SpuLeading.vue?vue&type=script&lang=ts"
export * from "./SpuLeading.vue?vue&type=script&lang=ts"
import style0 from "./SpuLeading.vue?vue&type=style&index=0&id=6cc81688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc81688",
  null
  
)

export default component.exports